module.exports = __webpack_public_path__ + "50c37b094636a8f18af40d02e02f2240.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/v/v07.jpg
// module id = 755
// module chunks = 0